
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/privacybeleid",
      function () {
        return require("private-next-pages/nl/privacybeleid.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/privacybeleid"])
      });
    }
  